/**
 * Translates between percentage-based coordinates and pixel coordinates
 * Percentages are 0-1 values representing portion of total width/height
 *
 * Used by widgets to convert their internal percentage-based layout to pixels
 */
export class HudPositionTranslator {
    readonly height: number;
    readonly width: number;

    constructor(dimensions: { height: number; width: number }) {
        this.height = dimensions.height;
        this.width = dimensions.width;
    }

    /**
     * Convert X percentage (0-1) to pixels
     */
    x(percent: number): number {
        return percent * this.width;
    }

    /**
     * Convert Y percentage (0-1) to pixels
     */
    y(percent: number): number {
        return percent * this.height;
    }
}
